const activeClients = (state = [], action) => {
    switch (action.type) {
        case "SET_ACTIVE_CLIENTS":
            return action.payload
        default:
            return state
    }
}

export default activeClients;